<template>
    <div class="section1">
        <div class="section bordered">
            <div class="content" data-section-name="generalinfo">
                <p>You are successfully logged in as <strong>{{ userInfo.name }}</strong></p>
                <p v-if="displayUpdateMessage"><b-badge variant="danger">IMPORTANT</b-badge> Due to inactivity, your account has been placed in hibernation status. Please click on <strong>'Personal Profile'</strong> below to update or confirm your ARM profile information before proceeding.</p>
                <div>
                    <b-button variant="arm-primary" class="mr-sm-2" @click="navPage('edit')">Personal Profile</b-button>
                    <b-button variant="arm-primary" class="mr-sm-2" @click="navPage('account')">Update Account Details</b-button>
                    <b-button variant="arm-primary" class="mr-sm-2" @click="navPage('update')">Subscriptions</b-button>
                    <b-button v-if="isDeveloper" variant="arm-primary" class="mr-sm-2" @click="navPage('resendEmail')">Resend Activation Email</b-button>
                    <b-button variant="arm-primary" class="mr-sm-2" @click="navPage('logout')">Logout</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<!--Dashboard Content refers to people-api therefore different naming convention for username-->
<script>
    import { mapState } from "vuex"
    export default {
        name: "DashboardContent",
        computed: {
            ...mapState("auth",["userInfo"]),
            ...mapState("profile",["isDeveloper"]),
            displayUpdateMessage() {
                return this.details && this.userInfo.exp && !this.$moment(this.userInfo.exp).isAfter(this.$moment().subtract(1, 'years')) ? true : false
            }
        },
        mounted() {
            this.$store.dispatch("profile/validateUserPermissions")
        },
        // methods: {
        //     navPage (pageName) {
        //         if (pageName == "logout") {
        //             this.$store.dispatch("auth/logout")
        //             this.$router.push({name: pageName})
        //         } else
        //             this.$router.push({path: `/${pageName}/${this.details.username}`})
        //     }
        // }
        methods: {
            async navPage(pageName) {
                const username = this.userInfo.preferred_username

                switch (pageName) {
                    case "edit":
                        this.$router.push({ name: "edit", params: { id: username } })
                        break
                    case "account":
                        this.$router.push({ name: "updateAccountDetails", params: { id: username } })
                        break
                    case "update":
                        this.$router.push({ name: "subscribe", params: { id: username } })
                        break
                    case "resendEmail":
                        this.$router.push({ name: "email" })
                        break
                    case "logout":
                        await this.$store.dispatch("auth/logout")
                        this.$router.push({ name: "login" }) // 'logout' route removed, redirect to login
                        break
                    default:
                        console.warn(`Unknown navigation target: ${pageName}`)
                }
            },
        },
    }
</script>

<style scoped>
    .btn {
        /* background-color: #00BD70 !important; */
    }
</style>
